import {IntermediatePart} from "../../intermediatePart";
import {Shower} from "../../parts/shower";

export default class CenterWall extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'center_wall';
    this.partName = 'Center Wall';
    this.translateId = "visualizer.bathroom.walls.center_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new CenterWall());
  }

  getArrayOfConditions() {
    const conditions = super.getArrayOfConditions(); // roomLayout
    const shower = this.getParent().layout.parts[Shower.id];
    if (shower && shower.showerSize()) {
      conditions.push({
        propName: "ShowerSize",
        propValue: shower.showerSize()
      })
    }
    return conditions
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Background.CenterWall;
      if (this.activeFeature) {
        this.activeFeature.layer.zIndex = zIndex;
      }
      if (this.placeholderFeature) {
        this.placeholderFeature.layer.zIndex = zIndex;
      }
    }
  }
}
